__turbopack_context__.v({
  "clickoff": "slidemenu-module-scss-module__poG4bG__clickoff",
  "close": "slidemenu-module-scss-module__poG4bG__close",
  "container": "slidemenu-module-scss-module__poG4bG__container",
  "hide": "slidemenu-module-scss-module__poG4bG__hide",
  "logo": "slidemenu-module-scss-module__poG4bG__logo",
  "menuGroup": "slidemenu-module-scss-module__poG4bG__menuGroup",
  "menuitems": "slidemenu-module-scss-module__poG4bG__menuitems",
  "show": "slidemenu-module-scss-module__poG4bG__show",
  "themenu": "slidemenu-module-scss-module__poG4bG__themenu",
});
